export enum CustomerFlowType {
  NewCustomer = 'NewCustomer', // Customer not found in customer SoR
  SingleCustomer = 'SingleCustomer', // Customer uniquely found by phone # in customer SoR but IDV has not occured yet
  MultipleCustomers = 'MultipleCustomers', // Multiple customers found in customer SoR by phone # with no IDV yet or multiple matches of last4 when attempting IDV
  VerifiedCustomer = 'VerifiedCustomer', // Customer has passed idv check (either last 4 verified or full SSN/DOB)
}
